import { render } from "./translate.vue?vue&type=template&id=6d335fe7&scoped=true"
import script from "./translate.vue?vue&type=script&lang=js"
export * from "./translate.vue?vue&type=script&lang=js"

import "./translate.vue?vue&type=style&index=0&id=6d335fe7&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d335fe7"],['__file',"vendor/wielink-application/translation/resources/vue/translation/translate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6d335fe7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6d335fe7', __exports__)) {
    console.log('reload')
    api.reload('6d335fe7', __exports__)
  }
  
  module.hot.accept("./translate.vue?vue&type=template&id=6d335fe7&scoped=true", () => {
    console.log('re-render')
    api.rerender('6d335fe7', render)
  })

}


export default __exports__